import { render } from "./DiagnosisBox.vue?vue&type=template&id=3ac60680&scoped=true"
import script from "./DiagnosisBox.vue?vue&type=script&lang=js"
export * from "./DiagnosisBox.vue?vue&type=script&lang=js"

import "./DiagnosisBox.vue?vue&type=style&index=0&id=3ac60680&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac60680"],['__file',"src/views/ProductDiagnosis/components/DiagnosisBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ac60680"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ac60680', __exports__)) {
    api.reload('3ac60680', __exports__)
  }
  
  module.hot.accept("./DiagnosisBox.vue?vue&type=template&id=3ac60680&scoped=true", () => {
    api.rerender('3ac60680', render)
  })

}


export default __exports__